import { render, staticRenderFns } from "./PaxInfo.vue?vue&type=template&id=edcd78a0"
import script from "./PaxInfo.vue?vue&type=script&lang=js"
export * from "./PaxInfo.vue?vue&type=script&lang=js"
import style0 from "./PaxInfo.vue?vue&type=style&index=0&id=edcd78a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports